// Pre-load voices for browsers that load them asynchronously (like Chrome)
if (typeof window !== "undefined" && window.speechSynthesis) {
    window.speechSynthesis.getVoices();
    if ("onvoiceschanged" in window.speechSynthesis) {
        window.speechSynthesis.onvoiceschanged = () => {
            window.speechSynthesis.getVoices();
        };
    }
}

function pickVoice(voices, lang) {
    if (!voices || voices.length === 0) return null;

    const targetLang = lang.toLowerCase().replace("_", "-");
    const primary = targetLang.split("-")[0];

    // 1. Exact match (normalized)
    let match = voices.find((v) => v.lang.toLowerCase().replace("_", "-") === targetLang);
    if (match) return match;

    // 2. Primary language match (e.g. de-DE/de-CH)
    match = voices.find((v) => v.lang.toLowerCase().replace("_", "-").startsWith(primary));
    if (match) return match;

    // 3. Fallback contains primary
    match = voices.find((v) => v.lang.toLowerCase().includes(primary));
    if (match) return match;

    return null;
}

export function speakText(text, lang, options = {}) {
    if (!window.speechSynthesis || !text) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = options.rate ?? 0.9;
    const voices = window.speechSynthesis.getVoices();
    const voice = pickVoice(voices, lang);
    if (voice) utterance.voice = voice;
    if (options.onEnd) utterance.onend = options.onEnd;
    if (options.onError) utterance.onerror = options.onError;
    window.speechSynthesis.speak(utterance);
}

// Whether the browser has any voice that can speak this language. speakText
// fails silently when there is none, which matters for listening-only exercises
// where audio is the entire prompt.
export function hasVoiceForLang(lang) {
    if (!window.speechSynthesis) return false;
    return pickVoice(window.speechSynthesis.getVoices(), lang) !== null;
}

export function stopSpeech() {
    if (window.speechSynthesis) {
        window.speechSynthesis.cancel();
    }
}

export const PRONUNCIATION_PASS_SCORE = 60;

